import styled from "styled-components";

export const Content = styled.div`
  text-align: center;
  font-size: 28px;
  font-family: "SpoqaHanSansNeo-Regular";
  line-height: 1.46;
  letter-spacing: 0.7px;
  text-align: center;
  color: #0d0d0d;
  margin: 0;
`;
